var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44561 2.64832H6.68797C4.73803 2.64832 3.76305 2.64832 3.15728 3.25981C2.55151 3.87131 2.55151 4.85551 2.55151 6.82389V8.21575C2.55151 10.1841 2.55151 11.1683 3.15728 11.7798C3.76305 12.3913 4.73803 12.3913 6.68797 12.3913H9.44561C11.3956 12.3913 12.3705 12.3913 12.9763 11.7798C13.5821 11.1683 13.5821 10.1841 13.5821 8.21575V6.82389C13.5821 4.85551 13.5821 3.87131 12.9763 3.25981C12.3705 2.64832 11.3956 2.64832 9.44561 2.64832Z",
    stroke: "white",
    strokeWidth: 1.22562
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00275 5.08398H6.84117",
    stroke: "white",
    strokeWidth: 1.22562,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3642 9.95557H11.1231C10.5528 9.95557 10.2677 9.95557 10.089 9.78036L10.0804 9.77176C9.90518 9.59304 9.90518 9.30792 9.90518 8.73769C9.90518 8.16746 9.90518 7.88234 10.0804 7.70362L10.089 7.69502C10.2677 7.51981 10.5528 7.51981 11.1231 7.51981H12.3642C12.9344 7.51981 13.2195 7.51981 13.3982 7.69502L13.4068 7.70362C13.582 7.88234 13.582 8.16746 13.582 8.73769C13.582 9.30792 13.582 9.59304 13.4068 9.77176L13.3982 9.78036C13.2195 9.95557 12.9344 9.95557 12.3642 9.95557Z",
    stroke: "white",
    strokeWidth: 1.22562
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletMobile);
export default __webpack_public_path__ + "static/media/wallet_mobile.8683212e56ef019d7d7f306dafaa736a.svg";
export { ForwardRef as ReactComponent };